import MarkdownContent from "../../../../../appfw/ui/components/MarkdownContent.tsx";
import {loadMd} from "../../../../../appfw/help-texts.ts";

export default function HelpGCalPage() {
    return (
        <MarkdownContent sx={{padding: {xs: 2, md: 4}, maxWidth: 960, marginInline: "auto"}}>
            {loadMd("gcal-help")}
        </MarkdownContent>
    )
}
